import { CUSTOMER_LABELS_TYPE } from 'apps/fleet-planner/constants/loads'

export const CUSTOMER_LABELS: Record<CUSTOMER_LABELS_TYPE, string> = {
  [CUSTOMER_LABELS_TYPE.TARGET_DEDICATED]: 'Target Dedicated',
} as const
